<template>
    <div class="custom_color" v-if="setData.getData().LightLastIsCustom && setData.getData().ColorsDynamic.Run == false"
        :style="{ backgroundColor }">
    </div>
</template>

<script setup lang="ts">
import { setData } from '@/service/driver/data';
import { getColorRGBA } from '@/tool/utility';
import { computed } from 'vue';
const props = defineProps<{
    kk: number
}>()
const backgroundColor = computed(() => {
    if (setData.getData().LightCustom[props.kk]) {
        const color = setData.getData().LightCustom[props.kk];
        return getColorRGBA(color, 1);
    }
    return ''; // 避免 undefined
});

</script>

<style scoped lang="less"></style>
